module.exports = __webpack_public_path__ + "static/media/Lockton Marine_RGB_NEG_2023.a45ede1b.svg";